import analytics from 'utils/analytics'

function addStories(stories=[], newStories){
  return Array.from(new Set(stories.concat(newStories)))
}


const accountsReducer = (state={}, action) => {
  switch (action.type) {
    case 'ADD_ACCOUNT':
      return {...state, ...action.payload}
    case 'SET_ACCOUNTS':
      analytics.set({accounts:Object.keys(action.payload || {}).length})
      return action.payload||{}
    case 'LOGOUT':
      return {}
    case 'ADD_STORIES':
      let account={...state[action.payload.account]}
      account.stories=addStories(account.stories, action.payload.data.result)
      return {
        ...state,
        [action.payload.account]:account
      }
    default:
      return state
    }
}


export default accountsReducer;



// WEBPACK FOOTER //
// ./src/utils/reducers/accounts.js